var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{attrs:{"headers":_vm.columns,"items":_vm.rows},scopedSlots:_vm._u([{key:"item.invoice.dueDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.invoice.dueDate))+" ")]}},{key:"item.pay",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticStyle:{"margin-right":"5px"},attrs:{"disabled":item.payed},on:{"click":function($event){return _vm.buy(item)}}},[_vm._v(" mdi-shopping ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }